
import { Outlet } from "react-router-dom";
import './Vat.scss';

export default function VAT(props: any) {
  return (
    <div className="VAT">
      <Outlet />
    </div>
  );
}
